import React, { useState } from "react";
import { Home, Gamepad2, Search, Menu, Trophy } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import styles from "./MobileBottomNav.module.css";
import MobileDrawer from "./MobileDrawer";
import SearchOverlay from "@/components/Navbar/SearchOverlay";

const MobileBottomNav = () => {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showSearchOverlay, setShowSearchOverlay] = useState(false);

  const navItems = [
    {
      id: "search",
      icon: Search,
      label: "Search",
      action: () => setShowSearchOverlay(true),
    },
    { id: "game", icon: Gamepad2, label: "Game", path: "/games" },
    { id: "home", icon: Home, label: "Home", path: "/", special: true },
    {
      id: "tournament",
      icon: Trophy,
      label: "Tournament",
      path: "/tournament",
    },
    {
      id: "menu",
      icon: Menu,
      label: "Menu",
      action: () => setDrawerOpen(true),
    },
  ];

  const isActive = (item) => {
    if (item.path) {
      return location?.pathname === item.path;
    }
    return false;
  };

  const handleNavClick = (item, e) => {
    if (item.action) {
      e.preventDefault();
      item.action();
    }
  };

  const getNavItemClassName = (item) => {
    return item.special ? styles.navItemSearch : styles.navItem;
  };

  const getIconWrapperClassName = (item) => {
    const active = isActive(item);
    if (item.special) {
      if (active) {
        return `${styles.iconWrapper} ${styles.iconWrapperSearch} ${styles.iconWrapperCenterActive}`;
      }
      return `${styles.iconWrapper} ${styles.iconWrapperCenter}`;
    }
    if (active) {
      return `${styles.iconWrapper} ${styles.iconWrapperActive}`;
    }
    return `${styles.iconWrapper} ${styles.iconWrapperDefault}`;
  };

  const getLabelClassName = (item) => {
    return `${styles.label} ${isActive(item) ? styles.labelActive : styles.labelDefault}`;
  };

  const getIconClassName = (item) => {
    const baseStyle = item.special ? styles.iconSearch : styles.icon;
    return `${baseStyle} ${isActive(item) ? styles.iconActive : styles.iconDefault}`;
  };

  const renderNavItem = (item) => {
    const Icon = item.icon;
    const columnMap = {
      search: 1,
      game: 2,
      home: 3,
      tournament: 4,
      menu: 5,
    };
    const gridColumn = columnMap[item.id] || "auto";
    const content = (
      <>
        <div className={getIconWrapperClassName(item)}>
          <div className={getIconClassName(item)}>
            <Icon />
          </div>
        </div>
        <span className={getLabelClassName(item)}>{item.label}</span>
      </>
    );

    if (item.action) {
      return (
        <button
          key={item.id}
          className={getNavItemClassName(item)}
          onClick={(e) => handleNavClick(item, e)}
          type="button"
          style={{ gridColumn }}
        >
          {content}
        </button>
      );
    }

    return (
      <Link
        key={item.id}
        to={item.path}
        className={getNavItemClassName(item)}
        style={{ gridColumn }}
        // onClick={(e) => {
        //   e.preventDefault();
        //   console.log('Navigate to:', item.path);
        // }}
      >
        {content}
      </Link>
    );
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navArc}></div>
        <div className={styles.navContainer}>{navItems.map(renderNavItem)}</div>
      </nav>

      {/* Drawer Overlay */}
      <div
        className={`${styles.drawerOverlay} ${drawerOpen ? styles.drawerOverlayVisible : styles.drawerOverlayHidden}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* Drawer */}
      <MobileDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <SearchOverlay
        isOpen={showSearchOverlay}
        onClose={() => setShowSearchOverlay(false)}
      />
    </>
  );
};

export default MobileBottomNav;
